import React, { memo } from 'react';
import { Game as CommonGame } from 'js/components/common/Game';

import style from './index.scss';

export default memo(({ gameCodes, showDivider, showGameInfo, showFeatureIcons = true, Game = CommonGame, container }) => (
    <div className={style.games}>
        {gameCodes.map(code =>
            <Game key={code}
                code={code}
                container={container}
                withFlexWidth={false}
                showGameInfo={showGameInfo}
                className={`${style.game} ${showDivider ? style.divider : ''}`}
                showFeatureIcons={showFeatureIcons}
            />
        )}
    </div>
));
